export default __webpack_public_path__ + "static/urzadzenia-serwisowe2-c6b75796725217401be87e137103c838.png";